import { useExtensions } from './hooks/extension.hook'
import { K3Main, ProvidedExtensionsProvider } from '@k3/core'
import React from 'react'

export const App = (): JSX.Element => {
  const { extensions } = useExtensions()
  return (
    <ProvidedExtensionsProvider extensions={extensions}>
      <K3Main />
     </ProvidedExtensionsProvider>
  )
}

export default App
